import { ref, computed } from 'vue';
import { useStore } from 'vuex';

export function useLikeComment(commentRef: {
  value: { id: string | number; likes?: number };
}) {
  const store = useStore();
  const isLikeLoading = ref(false);

  const likedComments = computed(() => store.state.comments.likedComments);

  const isCommentLiked = computed(() => {
    return likedComments.value.some(
      (item: { id: string | number }) => item.id === commentRef.value.id
    );
  });

  function likeIsLoading(loading = true) {
    isLikeLoading.value = loading;
  }

  function likeComment(comment: { id: string | number }) {
    return store.dispatch('comments/likeComment', comment);
  }

  function unlikeComment(payload: {
    comment: { id: string | number };
    likedInfo: { id: string | number };
  }) {
    return store.dispatch('comments/unlikeComment', payload);
  }

  function switchLikingComment() {
    likeIsLoading();

    if (isCommentLiked.value) {
      const likedInfo = likedComments.value.find(
        (item: { id: string | number }) => item.id === commentRef.value.id
      );

      unlikeComment({ comment: commentRef.value, likedInfo }).finally(() =>
        likeIsLoading(false)
      );
    } else {
      likeComment(commentRef.value).finally(() => likeIsLoading(false));
    }
  }

  return {
    isLikeLoading,
    likedComments,
    isCommentLiked,
    likeIsLoading,
    switchLikingComment,
  };
}
